import { makeStyles } from '@material-ui/core/styles'
import AccountAvatar from '../accountDetail/AccountAvatar'
import { Text } from '../../../1elements'
import { useParams } from 'react-router-dom'
import PhoneIcon from '@mui/icons-material/Phone'
import EmailIcon from '@mui/icons-material/Email'
import HomeIcon from '@mui/icons-material/Home'
import { useContext } from 'react'
import { GlobalContext } from '../../../../services/context/DataContext'
import { concatenateAddress, formatDate } from '../../../../services/util/formatter'

const ServiceDetailView = ({ data }) => {
  const { tabName } = useParams()
  const { contactContext, addressContext } = useContext(GlobalContext)
  const [contact] = contactContext
  const { created_at, first_name, last_name, isActive } = contact
  const [address] = addressContext
  const name = tabName === 'tab1' ? `${first_name || ''} ${last_name || ''}` : typeof data[0].fieldData === 'string' ? data[0].fieldData : ''
  const classes = useStyles({ tabName })

  const switchFieldLabel = (sysName, fieldLabel) => {
    switch (sysName) {
      case 'Field 77': // Contact Name
      case 'Field 120': // Service Name
        return null
      case 'Field 78': // Phone Number
        return <PhoneIcon className={classes.icon} style={{ fontSize: 18 }} />
      case 'Field 79': // Email Address
        return <EmailIcon className={classes.icon} style={{ fontSize: 18 }} />
      case 'Field 80': // Address
        return <HomeIcon className={classes.icon} style={{ fontSize: 18 }} />
      default:
        return <Text type='h9'>{fieldLabel}:&nbsp;</Text>
    }
  }

  const switchFieldValue = (sysName, fieldValue, type) => {
    switch (sysName) {
      case 'Field 77': // Contact Name
      case 'Field 120': // Service Name
        return null
      case 'Field 80': // Address
        return concatenateAddress(address)
      case 'Field 82': // Assigned Date
        return formatDate(created_at)
      default:
        if (type === 'Link') return <a href={fieldValue}>View</a>
        return fieldValue
    }
  }

  return (
    <div className={classes.root}>
      <AccountAvatar accountName={typeof name === 'string' ? name : ''} avatar={data[0].fieldData.avatar || ''} online={isActive} />
      <div className={classes.textDiv}>
        <Text type='h10' className={classes.serviceName}>{typeof name === 'string' && name}</Text>
        <div className={classes.dataGrid}>
          {
                        data && data.map((field) => {
                          const { isArchived, fieldId, sysName, fieldData, label, type } = field
                          const showField = !isArchived && sysName !== 'Field 77' && sysName !== 'Field 120' // The field is not archived && not for contact name && not for service name

                          if (showField) {
                            return (
                              <div className={`${classes.fieldRow} ${sysName === 'Field 80' && classes.addressField}`} key={fieldId}>
                                {switchFieldLabel(sysName, label)}
                                <Text type='p'>{switchFieldValue(sysName, fieldData, type)}</Text>
                              </div>
                            )
                          }
                          return ''
                        })
                    }
        </div>
      </div>
    </div>
  )
}

export default ServiceDetailView

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    alignItems: 'center'
  },
  serviceName: {
    color: theme.palette.tertiary.main
  },
  textDiv: {
    marginLeft: 20,
    flexGrow: 2
  },
  dataGrid: {
    padding: 0,
    display: 'grid',
    gridTemplateRows: props => props.tabName === 'tab1' ? 'repeat(3, 1fr)' : 'repeat(5, 1fr)',
    gridTemplateColumns: 'repeat(2, 1fr)',
    width: '100%',
    height: '100%'
  },
  dataFlex: {
    padding: 0,
    marginTop: 10,
    display: 'flex',
    width: '100%',
    height: '100%',
    maxHeight: 100,
    flexFlow: 'column wrap',
    maxWidth: 500,
    alignContent: 'space-between'
  },
  resetToDefaultButton: {
    position: 'absolute',
    right: 40,
    top: 20,
    zIndex: 1,
    '& .MuiButtonBase-root': {
      padding: 0
    }
  },
  fieldRow: {
    display: 'flex',
    alignItems: 'center',
    margin: '3px 0'
  },
  icon: {
    marginRight: 10,
    fontSize: 18,
    color: theme.palette.primary.main
  },
  addressField: {
    maxWidth: 250,
    height: 30
  }
}))
